import {
    Component,
    Element,
    Host,
    h,
    Listen,
    State,
    Watch,
} from "@stencil/core";

/**
 * @slot (default) - Slot for the detail items  (`<ux-iws-nb-all-in-one-detail>`)
 */
@Component({
    tag: "ux-iws-nb-all-in-one",
    styleUrl: "nb-all-in-one.scss",
    shadow: false,
})
export class NbAllInOne {
    private detailGroups: HTMLUxIwsNbAllInOneDetailGroupElement[] = [];
    private breakpointMediaQuery = window.matchMedia("(min-width: 1440px)");

    /** The element reference for the component. */
    @Element() host: HTMLUxIwsNbAllInOneElement;

    /** Storage for the currently active group */
    @State() activeGroup: string = "";

    @Listen("uxShow")
    onGroupShow(event: CustomEvent<string>) {
        const activeGroupName = event.detail;
        if (!activeGroupName) {
            return;
        }
        this.detailGroups = this.getDetailGroups();
        const activeGroup = this.detailGroups.find(
            (group) => group.group === activeGroupName
        );
        this.activeGroup = activeGroup ? activeGroupName : "";
    }

    @Listen("uxHide")
    onGroupHide(event: CustomEvent<string>) {
        const activeGroupName = event.detail;
        if (activeGroupName && activeGroupName === this.activeGroup) {
            this.activeGroup = "";
        }
    }

    @Watch("activeGroup")
    setActiveGroup() {
        const isDesktop = this.breakpointMediaQuery.matches;
        const numTiles = this.getTiles().length;
        this.detailGroups = this.getDetailGroups();
        this.detailGroups.forEach((group) => {
            group.active = group.group === this.activeGroup;
            group.style.order = isDesktop ? `${numTiles}` : "initial";
        });
    }

    private handleBreakpoint = () => {
        this.setActiveGroup();
    };

    private getTiles = (): HTMLUxIwsNbAllInOneTileElement[] => {
        return Array.from(
            this.host.querySelectorAll<HTMLUxIwsNbAllInOneTileElement>(
                "ux-iws-nb-all-in-one-tile"
            )
        );
    };

    private getDetailGroups = (): HTMLUxIwsNbAllInOneDetailGroupElement[] => {
        return Array.from(
            this.host.querySelectorAll<HTMLUxIwsNbAllInOneDetailGroupElement>(
                "ux-iws-nb-all-in-one-detail-group"
            )
        );
    };

    componentWillLoad() {
        const numTiles = this.getTiles().length;
        this.host.style.setProperty(
            "--tile-width",
            numTiles <= 1 ? "100%" : `${Math.floor(100 / numTiles)}%`
        );
        this.setActiveGroup();
    }

    componentDidLoad() {
        this.setActiveGroup();
    }

    connectedCallback() {
        this.breakpointMediaQuery.addEventListener(
            "change",
            this.handleBreakpoint
        );
    }

    disconnectedCallback() {
        this.breakpointMediaQuery.removeEventListener(
            "change",
            this.handleBreakpoint
        );
    }

    render() {
        const baseClass = "ux-iws-nb-all-in-one";
        return (
            <Host>
                <div class={`${baseClass}__box`}>
                    <slot />
                </div>
            </Host>
        );
    }
}
